import { render } from "./ServerWarningModal.vue?vue&type=template&id=655826ae&scoped=true"
import script from "./ServerWarningModal.vue?vue&type=script&lang=js"
export * from "./ServerWarningModal.vue?vue&type=script&lang=js"

import "./ServerWarningModal.vue?vue&type=style&index=0&id=655826ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655826ae"]])

export default __exports__